import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  compact?: boolean;
}

export function EmptyState({
  icon,
  title,
  description,
  actions,
  className,
  compact,
}: EmptyStateProps) {
  return (
    <div
      className={`${
        compact ? 'py-6' : 'py-10 px-4'
      } w-full flex flex-col items-center justify-center text-center ${
        className || ''
      }`}
    >
      {icon ? (
        <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400">
          {icon}
        </div>
      ) : null}
      {title ? (
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">
          {title}
        </h3>
      ) : null}
      {description ? (
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {description}
        </p>
      ) : null}
      {actions ? <div className="mt-4">{actions}</div> : null}
    </div>
  );
}
